// extracted by mini-css-extract-plugin
export default {"external":"Auth_external__tEA9-","content":"Auth_content__XWoVG","invalid":"Auth_invalid__NTml9"};